import { useAppSelector } from "../../app/hooks"
import { StateRoute } from "../../models/Page";

const useStateLocation = (): StateRoute => {
  const state = useAppSelector(state => state);
  return state.page.route;
}

export default useStateLocation;
